import type { DeviceResponse, MyDevicesResponse } from "@jti/rest-api-types";

export interface DeviceApiContract {
  myDevices(userId?: string): Promise<MyDevicesResponse>;
  registerDevice(
    registrationCode: string,
    userId?: string,
    token?: string,
    ciam_token?: string
  ): Promise<DeviceResponse>;
  deleteDevice(id: string, userId?: string, ciamToken?: string): Promise<MyDevicesResponse>;
  checkDeviceIdForRegistration(id: string): Promise<undefined>;
  assignDeviceToUser(deviceId: string, userId?: string, ciamToken?: string): Promise<DeviceResponse>;
}
